import BlockIcon from "@mui/icons-material/Block";
import { Box, Typography } from "@mui/material";
import { usePermissions } from "context/PermissionsProvider";
import { Permissions } from "data/permissons";

interface Props {
  name: Permissions | Array<string>;
  children: React.ReactNode | null;
}

function PageWithPermission({ name, children }: Props) {
  let { permissions, role } = usePermissions();

  if (role?.defaultRole) {
    return <>{children}</>;
  }

  if (Array.isArray(name)) {
    let isPermitted = name.some((item) => permissions.includes(item));
    return isPermitted ? <>{children}</> : <PermissionDenied />;
  }

  if (permissions.includes(name)) {
    return <>{children}</>;
  }

  return <PermissionDenied />;
}

// Also used on its own (e.g. a tab the user can't open), with an optional explanation
export const PermissionDenied = ({
  message,
  minHeight = "80vh",
}: {
  message?: string;
  minHeight?: string | number;
}) => (
  <Box minHeight={minHeight} display="flex" justifyContent="center" alignItems="center">
    <Box p={2} borderRadius={2} minWidth={300} textAlign="center" bgcolor="rgb(253, 237, 237)">
      <BlockIcon
        fontSize="large"
        sx={{
          color: "rgb(95, 33, 32)",
        }}
      />
      <Typography variant="subtitle2" color="rgb(95, 33, 32)">
        Permission Denied
      </Typography>
      {message && (
        <Typography variant="body2" color="rgb(95, 33, 32)" mt={0.5}>
          {message}
        </Typography>
      )}
    </Box>
  </Box>
);

export default PageWithPermission;
